<div>
  <label class="label">{{ leftLabel | lang | uppercase }}</label>
  <label class="switch">
    <input [disabled]="disabledSwitch" type="checkbox" [checked]="status" (click)="switch($event)">
    <span class="slider round" [ngStyle]="{'background-color': switchColor}"></span>
  </label>
  <label class="label">{{ rightLabel | lang | uppercase }}</label>
</div>
